module.exports = __webpack_public_path__ + "static/media/diamonds-king.869dc96c.png";